import { LoginCard } from '~/ComponentsTW/layout/login-card';
import { AlertBox, Button, Form, FormLabel, Icon, PasswordInput, StandaloneLink } from '~/ComponentsTW/wm';
import * as React from 'react';
import { useEffect, useState } from 'react';
import generatePassword from 'utils/generatePassword';
import { apiRequest } from 'utils/request';
import validatePassword from 'utils/validatePassword';

export function ResetPassword({ onAlert, code, backToLogin }) {
    const
        [loading, setLoading] = useState(false),
        [password, setPassword] = useState(''),
        [passwordConfirmation, setPasswordConfirmation] = useState(''),
        [passwordRequirements, setPasswordRequirements] = useState(validatePassword(password, passwordConfirmation));

    useEffect(() => {
        setPasswordRequirements(validatePassword(password, passwordConfirmation));
    }, [password, passwordConfirmation]);

    const canSubmit = Object.values(passwordRequirements).every(req => req.met);

    const handleGeneratePassword = () => {
        const generatedPassword = generatePassword();
        setPassword(generatedPassword);
    };

    const onHandleSubmit = async event => {
        event.preventDefault();
        setLoading(true);

        const data = {
            password,
            password_confirmation: passwordConfirmation
        };

        try {
            const response = await apiRequest(`/reset_password/${code}`, 'PUT', data);

            if (response.status === 200) {
                onAlert('Successfully changed password', 'success', 'Success');
                backToLogin();
            }
        } catch (err) {
            const errorMessage = err.response?.data?.error || 'An error occurred';

            onAlert(errorMessage, 'destructive', 'Failed');
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 500);
        }
    };

    return (
        <div className="tw-grid tw-grid-cols-1">
            <LoginCard>
                <Form>
                    <FormLabel htmlFor="email">insert a new password</FormLabel>
                    <PasswordInput
                        id="password"
                        onChange={e => setPassword(e.target.value)}
                        required
                        value={password}
                    />
                    <FormLabel htmlFor="email">confirm the new password</FormLabel>
                    <PasswordInput
                        id="password_confirmation"
                        onChange={e => setPasswordConfirmation(e.target.value)}
                        required
                        value={passwordConfirmation}
                    />
                    <Button className="tw-w-full" disabled={!canSubmit} loading={loading} onClick={onHandleSubmit} type="submit" variant="secondary">
                        Submit
                    </Button>
                </Form>
            </LoginCard>
            <AlertBox active={true} title="Password requirements" variant="info">
                {
                    <div>
                        <ul className="tw-space-y-2 tw-list-none tw-p-0 tw-m-0 tw-mt-2">
                            {Object.entries(passwordRequirements || {}).map(([key, { met, message }]) => (
                                <li className="tw-flex tw-items-center tw-w-full tw-text-xs" key={key}>
                                    {met ? (
                                        <Icon color="success" icon="circleCheck" size="small"/>
                                    ) : (
                                        <Icon color="destructive" icon="exclamationCircle" size="small"/>
                                    )}
                                    {message}
                                </li>
                            ))}
                        </ul>
                        <Button className="tw-w-full tw-mt-3" onClick={handleGeneratePassword} variant="info">
                            Generate a Password
                        </Button>
                    </div>
                }
            </AlertBox>
            <StandaloneLink icon="arrowLeftCircle" onAction={backToLogin} text="Back to Login"/>
        </div>
    );
}
